(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  var nav = document.querySelector('[data-nav]');
  var toggle = document.querySelector('[data-nav-toggle]');

  // Header: transparent at the top of the page, solid once the page scrolls.
  var heroStage = document.querySelector('.vhero__stage');
  function paintHeader() {
    if (!header) return;
    var open = nav && nav.classList.contains('is-open');
    header.classList.toggle('is-solid', window.scrollY > 8 || open);
    // On the home page the header floats over the hero until you scroll past it.
    if (heroStage) {
      var past = heroStage.getBoundingClientRect().bottom <= header.offsetHeight + 8;
      header.classList.toggle('is-past', past);
    } else {
      header.classList.add('is-past');
    }
  }

  // Measure once and again only when the width changes. Mobile browsers fire
  // resize while scrolling (the address bar shows and hides), which used to
  // make the header jump.
  var announce = document.querySelector('.announce');
  var lastWidth = 0;
  function measureHeader() {
    if (!header) return;
    var w = window.innerWidth;
    if (w === lastWidth) return;
    lastWidth = w;
    var root = document.documentElement.style;
    root.setProperty('--header-h', header.offsetHeight + 'px');
    root.setProperty('--announce-h', (announce ? announce.offsetHeight : 0) + 'px');
  }

  if (header) {
    paintHeader();
    measureHeader();
    window.addEventListener('scroll', paintHeader, { passive: true });
    window.addEventListener('resize', measureHeader, { passive: true });
  }

  // Mobile menu
  function setNav(open) {
    if (!nav || !toggle) return;
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    paintHeader();
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      setNav(!nav.classList.contains('is-open'));
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        setNav(false);
        toggle.focus();
      }
    });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    var min = parseInt(input.min, 10) || 1;
    box.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
    });
    box.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || min) + 1;
    });
  });

  // Collection sorting
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  // Product wheel. One number, `turn`, drives everything: 0 is the ring,
  // 1 is the drum with the first product at the front, and each whole number
  // after that is one more product turned past.
  document.querySelectorAll('[data-wheel]').forEach(function (root) {
    var stage = root.querySelector('[data-wheel-stage]');
    var drum = root.querySelector('[data-wheel-drum]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-wheel-card]'));
    var label = root.querySelector('[data-wheel-label]');
    var infoWrap = root.querySelector('[data-wheel-infos]');
    var infos = Array.prototype.slice.call(root.querySelectorAll('[data-wheel-info]'));
    var gos = Array.prototype.slice.call(root.querySelectorAll('[data-wheel-go]'));
    var count = cards.length;
    if (!stage || !count) return;

    var STEP = 40, WHEEL_UNITS = 600, DRAG_UNITS = 300, SETTLE = 140, EASE = 0.12, CULL = 1.6;
    var last = count - 1;
    var turn = 0, target = 0, active = -1, frame = 0, settling = 0, M = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var clamp = function (v, lo, hi) { return Math.min(hi, Math.max(lo, v)); };

    root.classList.add('is-ready');

    function measure() {
      var w = stage.clientWidth, h = stage.clientHeight, narrow = w < 700;
      if (!w || !h) return;
      var card = Math.min(h * (narrow ? 0.42 : 0.46), w * (narrow ? 0.5 : 0.34));
      var ringR = Math.min(card * 1.14, h * 0.36, w * 0.38);
      M = {
        card: card,
        ringR: ringR,
        ringScale: clamp(((2 * Math.PI * ringR) / count) * 0.82 / card, 0.16, 1),
        drumR: card * 2.22,
        bow: card * (narrow ? 0.9 : 1.82)
      };
      stage.style.perspective = card * 2.7 + 'px';
      cards.forEach(function (el) {
        el.style.width = el.style.height = card + 'px';
        el.style.marginLeft = el.style.marginTop = -card / 2 + 'px';
      });
      kick();
    }

    function draw() {
      var gap = target - turn;
      if (Math.abs(gap) < 0.0005) turn = target;
      else turn += gap * (reduced ? 1 : EASE);

      var m = clamp(turn, 0, 1);
      var pos = Math.max(0, turn - 1);
      drum.style.transform = 'translateZ(' + -m * M.drumR + 'px)';

      for (var i = 0; i < count; i++) {
        var d = i - pos;
        var drumDeg = d * STEP;
        var bow = -M.bow * (1 - Math.cos((drumDeg * Math.PI) / 180));
        var el = cards[i];
        el.style.transform =
          'translateX(' + m * bow + 'px)' +
          ' rotateZ(' + (1 - m) * d * (360 / count) + 'deg) translateY(' + -(1 - m) * M.ringR + 'px)' +
          ' rotateX(' + m * drumDeg + 'deg) translateZ(' + m * M.drumR + 'px)';
        var gone = m > 0.5 && Math.abs(d) > CULL;
        el.style.opacity = gone ? '0' : '1';
        el.style.pointerEvents = gone ? 'none' : '';
        el.style.zIndex = String(Math.round(100 - Math.abs(d) * 2));
        el.firstElementChild.style.transform = 'scale(' + (M.ringScale + (1 - M.ringScale) * m) + ')';
      }

      if (label) label.style.opacity = String(1 - m);
      if (infoWrap) infoWrap.style.opacity = String(m);

      var near = clamp(Math.round(pos), 0, last);
      if (near !== active) {
        active = near;
        stage.setAttribute('aria-activedescendant', cards[near].id);
        cards.forEach(function (el, i) { el.setAttribute('aria-selected', i === near ? 'true' : 'false'); });
        infos.forEach(function (el, i) { el.hidden = i !== near; });
        gos.forEach(function (el, i) { el.setAttribute('aria-current', i === near ? 'true' : 'false'); });
      }

      frame = turn === target ? 0 : requestAnimationFrame(draw);
    }

    function kick() { if (!frame && M) frame = requestAnimationFrame(draw); }
    function to(next) { target = clamp(next, 0, last + 1); kick(); }

    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(stage);
    else window.addEventListener('resize', measure);

    // Open the ring into the drum the first time the wheel is properly in view.
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (target < 1) to(1);
          seen.disconnect();
        }
      }, { threshold: 0.6 });
      seen.observe(stage);
    } else {
      to(1);
    }

    // Mouse wheel and trackpad turn the drum, and let the page scroll on at either end.
    stage.addEventListener('wheel', function (event) {
      if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;
      var next = target + event.deltaY / WHEEL_UNITS;
      if (next > 1 && next < last + 1) event.preventDefault();
      to(Math.max(1, next));
      window.clearTimeout(settling);
      settling = window.setTimeout(function () { to(Math.round(target)); }, SETTLE);
    }, { passive: false });

    // Drag: up and down with a mouse, sideways on touch so the page still scrolls.
    var drag = null, moved = 0;
    stage.addEventListener('pointerdown', function (event) {
      drag = { x: event.clientX, y: event.clientY, touch: event.pointerType !== 'mouse' };
      moved = 0;
    });
    window.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var delta = drag.touch ? drag.x - event.clientX : drag.y - event.clientY;
      moved += Math.abs(delta);
      if (moved > 6) to(Math.max(1, target + delta / DRAG_UNITS));
      drag.x = event.clientX;
      drag.y = event.clientY;
    });
    var release = function () {
      if (!drag) return;
      drag = null;
      to(Math.round(target));
    };
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);

    // A click on a side card brings it to the front; a click after a drag does nothing.
    cards.forEach(function (el, i) {
      el.addEventListener('dragstart', function (event) { event.preventDefault(); });
      el.addEventListener('click', function (event) {
        if (moved > 6 || i !== active || target < 1) {
          event.preventDefault();
          if (moved <= 6) to(i + 1);
        }
      });
    });

    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') to(Math.round(target) + 1);
      else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') to(Math.max(1, Math.round(target) - 1));
      else return;
      event.preventDefault();
    });

    gos.forEach(function (el, i) { el.addEventListener('click', function () { to(i + 1); }); });
    var prev = root.querySelector('[data-wheel-prev]');
    var next = root.querySelector('[data-wheel-next]');
    if (prev) prev.addEventListener('click', function () { to(Math.max(1, Math.round(target) - 1)); });
    if (next) next.addEventListener('click', function () { to(Math.round(target) + 1); });
  });

  // Location card: tilts toward the pointer, opens into a street pattern on click.
  document.querySelectorAll('[data-map]').forEach(function (root) {
    var card = root.querySelector('[data-map-card]');
    var hint = root.querySelector('[data-map-hint]');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var live = root.querySelector('[data-map-live]');
    card.addEventListener('click', function () {
      var open = card.getAttribute('aria-expanded') !== 'true';
      card.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-open', open);
      if (hint) hint.hidden = open;
      if (live) {
        live.hidden = !open;
        // Load the Google map only the first time the card is opened.
        if (open && !live.firstChild) {
          var frame = document.createElement('iframe');
          frame.src = live.getAttribute('data-src');
          frame.title = live.getAttribute('data-title');
          frame.loading = 'lazy';
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.allowFullscreen = true;
          live.appendChild(frame);
        }
      }
    });
    if (still) return;
    root.addEventListener('mousemove', function (event) {
      var box = card.getBoundingClientRect();
      var x = Math.max(-50, Math.min(50, event.clientX - (box.left + box.width / 2)));
      var y = Math.max(-50, Math.min(50, event.clientY - (box.top + box.height / 2)));
      card.style.setProperty('--rx', (-y / 50) * 8 + 'deg');
      card.style.setProperty('--ry', (x / 50) * 8 + 'deg');
    });
    root.addEventListener('mouseleave', function () {
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    });
  });

  // Card fan: seven cards spread like a hand, the middle one is the current product.
  document.querySelectorAll('[data-fan]').forEach(function (fan) {
    var stage = fan.querySelector('[data-fan-stage]');
    var cards = Array.prototype.slice.call(fan.querySelectorAll('[data-fan-card]'));
    var dots = Array.prototype.slice.call(fan.querySelectorAll('[data-fan-dot]'));
    var root = fan.closest('[data-wheel]');
    var infos = root ? Array.prototype.slice.call(root.querySelectorAll('[data-wheel-info]')) : [];
    var total = cards.length;
    if (!total) return;
    var SLOTS = [
      { rot: -21, scale: 0.7756, x: -30, y: 7.3 }, { rot: -14, scale: 0.8498, x: -22, y: 4 }, { rot: -7, scale: 0.9346, x: -11, y: 1.3 },
      { rot: 0, scale: 1, x: 0, y: 0 },
      { rot: 7, scale: 0.9346, x: 11, y: 1.3 }, { rot: 14, scale: 0.8498, x: 22, y: 4 }, { rot: 21, scale: 0.7756, x: 30, y: 7.3 }
    ];
    var half = Math.min(3, Math.floor((total - 1) / 2));
    var center = 0, entered = false, swiped = false;

    function spread() {
      var w = window.innerWidth;
      return w < 480 ? 0.28 : w < 640 ? 0.38 : w < 768 ? 0.5 : 0.75;
    }

    function layout() {
      var mult = spread();
      cards.forEach(function (card, i) {
        var d = ((i - center) % total + total) % total;
        if (d > total / 2) d -= total;
        if (Math.abs(d) <= half) {
          var slot = SLOTS[d + 3];
          card.style.transform = 'translate(' + slot.x * mult + 'rem, ' + slot.y + 'rem) rotate(' + slot.rot + 'deg) scale(' + slot.scale + ')';
          card.style.opacity = '1';
          card.style.zIndex = String(10 - Math.abs(d));
          card.style.pointerEvents = '';
          card.style.transitionDelay = entered ? '0s' : 0.06 * (d + 3) + 's';
        } else {
          var side = d > 0 ? 1 : -1;
          card.style.transform = 'translate(' + side * 40 * mult + 'rem, 7rem) rotate(' + side * 30 + 'deg) scale(.5)';
          card.style.opacity = '0';
          card.style.zIndex = '0';
          card.style.pointerEvents = 'none';
          card.style.transitionDelay = '0s';
        }
        card.setAttribute('aria-current', d === 0 ? 'true' : 'false');
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === center); });
      if (window.matchMedia('(max-width: 899px)').matches) {
        infos.forEach(function (el, i) { el.hidden = i !== center; });
      }
      entered = true;
    }

    function go(next) { center = ((next % total) + total) % total; layout(); }

    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { layout(); seen.disconnect(); }
      }, { threshold: 0.35 });
      seen.observe(stage);
    } else {
      layout();
    }
    window.addEventListener('resize', function () { if (entered) layout(); });

    fan.querySelector('[data-fan-prev]').addEventListener('click', function () { go(center - 1); });
    fan.querySelector('[data-fan-next]').addEventListener('click', function () { go(center + 1); });

    // Swipe sideways to move through the cards; up and down still scrolls the page.
    var startX = null;
    stage.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; swiped = false; }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var dx = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 36) { swiped = true; go(center + (dx < 0 ? 1 : -1)); }
    });

    // A side card comes to the middle when tapped; the middle card opens its product.
    cards.forEach(function (card, i) {
      card.addEventListener('click', function (event) {
        if (swiped || i !== center) {
          event.preventDefault();
          if (!swiped) go(i);
        }
      });
    });
  });

  // Photo hero: the round thumbnails swap the background photo.
  document.querySelectorAll('[data-phero]').forEach(function (hero) {
    var bg = hero.querySelector('.phero__bg');
    var thumbs = Array.prototype.slice.call(hero.querySelectorAll('[data-phero-thumb]'));
    if (!bg || bg.tagName !== 'IMG') return;
    thumbs.forEach(function (thumb) {
      if (thumb.getAttribute('data-phero-thumb') === bg.getAttribute('src')) thumb.setAttribute('aria-pressed', 'true');
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-phero-thumb');
        thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false'); });
        bg.classList.add('is-swapping');
        window.setTimeout(function () {
          bg.removeAttribute('srcset');
          bg.removeAttribute('sizes');
          bg.src = src;
          bg.classList.remove('is-swapping');
        }, 300);
      });
    });
  });

  // Product slider arrows.
  document.querySelectorAll('[data-pslide]').forEach(function (root) {
    var rail = root.querySelector('[data-pslide-rail]');
    var prev = root.querySelector('[data-pslide-prev]');
    var next = root.querySelector('[data-pslide-next]');
    if (!rail) return;
    var step = function () { var item = rail.firstElementChild; return item ? item.getBoundingClientRect().width + 18 : 300; };
    var update = function () {
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
    };
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    update();
  });

  // Catalogue coverflow. `pos` is the fractional card index at the centre;
  // every card's transform is derived from it, and the ring loops by folding
  // each card's offset into the shorter way round.
  document.querySelectorAll('[data-cover]').forEach(function (root) {
    var frame = root.querySelector('[data-cover-frame]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cover-card]'));
    var captions = Array.prototype.slice.call(root.querySelectorAll('[data-cover-caption]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cover-dot]'));
    var counter = root.querySelector('[data-cover-index]');
    var count = cards.length;
    if (!frame || !count) return;

    var ROTATE = 44, DEPTH = 0.6, PERSPECTIVE = 3, FALLOFF = 0.56, FADE = 0.1, GAP = 0.05;
    var loop = count > 2;
    var pos = 0, target = 0, width = 0, raf = 0, selected = -1, drag = null, moved = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function indexAt(p) { return ((Math.round(p) % count) + count) % count; }
    function clampPos(p) { return loop ? p : Math.max(0, Math.min(count - 1, p)); }

    function select(i) {
      if (i === selected) return;
      selected = i;
      captions.forEach(function (el, k) { el.hidden = k !== i; });
      dots.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
      if (counter) counter.textContent = String(i + 1);
    }

    function paint() {
      if (!width) return;
      var pitch = width * (1 + GAP);
      cards.forEach(function (card, index) {
        var offset = index - pos;
        if (loop) {
          offset = ((offset % count) + count) % count;
          if (offset > count / 2) offset -= count;
        }
        var distance = Math.abs(offset);
        var ramp = Math.pow(distance, FALLOFF);
        var tilt = Math.min(ROTATE * ramp, 82) * Math.sign(offset);
        card.style.transform = 'translateX(calc(-50% + ' + offset * pitch + 'px)) translateZ(' + -DEPTH * width * ramp + 'px) rotateY(' + -tilt + 'deg)';
        var edge = loop ? Math.min(1, Math.max(0, count / 2 - distance)) : 1;
        card.style.opacity = String(Math.max(0, 1 - FADE * distance) * edge);
        card.style.zIndex = String(100 - Math.round(distance));
      });
      select(indexAt(pos));
    }

    function settle(t) {
      if (raf) cancelAnimationFrame(raf);
      target = t;
      select(indexAt(t));
      if (reduced) { pos = t; paint(); raf = 0; return; }
      var step = function () {
        var remaining = target - pos;
        if (Math.abs(remaining) < 0.0004) { pos = target; paint(); raf = 0; return; }
        pos += remaining * 0.16;
        paint();
        raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }

    function goTo(i) { settle(clampPos(loop ? i + Math.round((target - i) / count) * count : i)); }
    function nudge(by) { settle(clampPos(Math.round(target) + by)); }

    function measure() {
      width = cards[0].offsetWidth;
      frame.style.perspective = width * PERSPECTIVE + 'px';
      paint();
    }
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(frame);
    else window.addEventListener('resize', measure);

    frame.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button')) return;
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      target = pos;
      moved = 0;
      drag = { id: event.pointerId, x: event.clientX, pos: pos, v: 0, t: performance.now() };
      frame.setPointerCapture(event.pointerId);
    });
    frame.addEventListener('pointermove', function (event) {
      if (!drag || drag.id !== event.pointerId) return;
      var pitch = width * (1 + GAP);
      if (!pitch) return;
      var now = performance.now();
      var previous = pos;
      moved = Math.max(moved, Math.abs(event.clientX - drag.x));
      pos = clampPos(drag.pos - (event.clientX - drag.x) / pitch);
      drag.v = ((pos - previous) / Math.max(now - drag.t, 1)) * 1000;
      drag.t = now;
      paint();
    });
    var endDrag = function (event) {
      if (!drag || drag.id !== event.pointerId) return;
      var v = drag.v;
      drag = null;
      if (moved < 6) {
        // A tap: bring the tapped card to the front.
        var hit = document.elementFromPoint(event.clientX, event.clientY);
        var card = hit && hit.closest('[data-cover-card]');
        if (card) { goTo(cards.indexOf(card)); return; }
      }
      settle(clampPos(Math.round(pos + Math.max(-2, Math.min(2, v * 0.18)))));
    };
    frame.addEventListener('pointerup', endDrag);
    frame.addEventListener('pointercancel', endDrag);

    frame.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); nudge(-1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); nudge(1); }
    });
    var prev = root.querySelector('[data-cover-prev]');
    var next = root.querySelector('[data-cover-next]');
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
  });

  // Place your order: save any edited quantities, read the live cart, and open
  // WhatsApp with the order written out (items, total, delivery or pickup).
  document.querySelectorAll('[data-wa-order]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      if (!window.fetch) return;
      event.preventDefault();
      var form = button.closest('form');
      var updates = form ? Array.prototype.map.call(form.querySelectorAll('input[name="updates[]"]'), function (input) { return Math.max(0, parseInt(input.value, 10) || 0); }) : [];
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var money = function (cents) { return 'AED ' + (cents / 100).toFixed(2); };
      var threshold = (parseFloat(button.getAttribute('data-threshold')) || 500) * 100;
      var save = updates.length
        ? fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        : Promise.resolve();
      save
        .then(function () { return fetch(root + 'cart.js'); })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (!cart.items.length) { window.location.reload(); return; }
          var lines = cart.items.map(function (item, i) {
            var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
            return (i + 1) + '. ' + item.product_title + variant + ' x ' + item.quantity + ' = *' + money(item.final_line_price) + '*';
          });
          var plan = cart.total_price >= threshold
            ? 'Delivery: my order is ' + money(threshold) + ' or more, so please deliver it.\nMy delivery address: (please type your full address here)'
            : 'Pickup: my order is under ' + money(threshold) + ', so I will collect it from your ' + button.getAttribute('data-pickup') + ' location. Please send me the location and a pickup time.';
          var text = 'Hello ' + button.getAttribute('data-shop') + ', I would like to place an order:\n\n' + lines.join('\n') +
            '\n\n*Order total: ' + money(cart.total_price) + '*\n\n' + plan + '\n\nPlease send me the secure payment link once you have checked inventory and stock. Thank you, I appreciate your patience.';
          var url = 'https://wa.me/' + button.getAttribute('data-wa-number') + '?text=' + encodeURIComponent(text);
          var dialog = document.querySelector('[data-wa-confirm]');
          if (!dialog || typeof dialog.showModal !== 'function') { window.location.href = url; return; }
          var go = dialog.querySelector('[data-wa-go]');
          go.href = url;
          dialog.showModal();
          go.focus();
        })
        .catch(function () { window.location.href = button.href; });
    });
  });

  // Contact globe: a slowly turning outline of the world with a pin on Dubai.
  document.querySelectorAll('[data-globe]').forEach(function (box) {
    if (!window.d3 || !window.d3.geoOrthographic || !window.topojson) return;
    var canvas = box.querySelector('canvas');
    var ctx = canvas.getContext('2d');
    var pin = [parseFloat(box.getAttribute('data-lng')), parseFloat(box.getAttribute('data-lat'))];
    var styles = getComputedStyle(document.documentElement);
    var ink = styles.getPropertyValue('--grove').trim() || '#2a3819';
    var red = styles.getPropertyValue('--red').trim() || '#ba171c';
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rotation = [-pin[0] + 40, -18];
    var land = null, size = 0, visible = false, drag = null, frame = 0, last = 0;
    var projection = d3.geoOrthographic().precision(0.3).clipAngle(90);
    var path = d3.geoPath(projection, ctx);
    var graticule = d3.geoGraticule10();

    function resize() {
      size = Math.min(box.clientWidth, 460);
      var ratio = window.devicePixelRatio || 1;
      canvas.width = size * ratio;
      canvas.height = size * ratio;
      canvas.style.width = size + 'px';
      canvas.style.height = size + 'px';
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      projection.scale(size / 2 - 4).translate([size / 2, size / 2]);
      draw();
    }

    function draw() {
      if (!size) return;
      projection.rotate(rotation);
      ctx.clearRect(0, 0, size, size);
      ctx.lineWidth = 1;
      ctx.globalAlpha = 0.12; ctx.strokeStyle = ink;
      ctx.beginPath(); path(graticule); ctx.stroke();
      ctx.globalAlpha = 0.75; ctx.lineWidth = 0.7;
      if (land) { ctx.beginPath(); path(land); ctx.stroke(); }
      ctx.globalAlpha = 0.9; ctx.lineWidth = 1.4;
      ctx.beginPath(); path({ type: 'Sphere' }); ctx.stroke();
      var centre = projection.invert([size / 2, size / 2]);
      if (d3.geoDistance(pin, centre) < Math.PI / 2 - 0.05) {
        var p = projection(pin);
        ctx.globalAlpha = 0.25; ctx.fillStyle = red;
        ctx.beginPath(); ctx.arc(p[0], p[1], 10, 0, 2 * Math.PI); ctx.fill();
        ctx.globalAlpha = 1;
        ctx.beginPath(); ctx.arc(p[0], p[1], 4.5, 0, 2 * Math.PI); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    function tick(time) {
      frame = 0;
      if (!visible || drag || still) return;
      var dt = last ? Math.min(time - last, 50) : 16;
      last = time;
      rotation[0] = (rotation[0] + dt * 0.012) % 360;
      draw();
      frame = requestAnimationFrame(tick);
    }
    function play() { if (!frame && !still) { last = 0; frame = requestAnimationFrame(tick); } }

    fetch(box.getAttribute('data-world'))
      .then(function (r) { return r.json(); })
      .then(function (world) { land = topojson.feature(world, world.objects.countries); draw(); })
      .catch(function () {});

    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(box);
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) play();
    }, { threshold: 0.1 }).observe(box);

    box.addEventListener('pointerdown', function (event) {
      drag = { x: event.clientX, y: event.clientY };
      box.setPointerCapture(event.pointerId);
    });
    box.addEventListener('pointermove', function (event) {
      if (!drag) return;
      rotation[0] += (event.clientX - drag.x) * 0.4;
      rotation[1] = Math.max(-60, Math.min(60, rotation[1] - (event.clientY - drag.y) * 0.4));
      drag = { x: event.clientX, y: event.clientY };
      draw();
    });
    var stop = function () { if (drag) { drag = null; play(); } };
    box.addEventListener('pointerup', stop);
    box.addEventListener('pointercancel', stop);
  });

  // Video hero entrance: one pass after fonts are ready and the video has data.
  document.querySelectorAll('[data-vhero]').forEach(function (hero) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var video = hero.querySelector('[data-vhero-video]');
    var done = false;
    function reveal() { hero.classList.remove('is-pre'); }
    if (reduced || hero.hasAttribute('data-vhero-static') || !Element.prototype.animate) { reveal(); return; }
    var failsafe = setTimeout(function () { done = true; reveal(); }, 3500);
    var expo = 'cubic-bezier(0.16, 1, 0.3, 1)';
    var quart = 'cubic-bezier(0.25, 1, 0.5, 1)';
    function run() {
      if (done) return;
      done = true;
      clearTimeout(failsafe);
      var cta = hero.querySelector('[data-vhero-cta]');
      var scale = (cta ? cta.offsetHeight / 46 : 1) * (window.innerWidth < 650 ? 0.8 : 1);
      var px = function (n) { return Math.round(n * scale) + 'px'; };
      var anims = [];
      function lift(el, from, delay, dur, ease) {
        if (!el) return;
        anims.push(el.animate([{ opacity: 0, transform: 'translateY(' + from + ')' }, { opacity: 1, transform: 'none' }], { duration: dur, delay: delay, easing: ease, fill: 'backwards' }));
      }
      hero.querySelectorAll('[data-vhero-line]').forEach(function (line, i) {
        anims.push(line.animate([{ transform: 'translateY(115%)' }, { transform: 'none' }], { duration: 1050, delay: 380 + i * 90, easing: expo, fill: 'backwards' }));
      });
      lift(hero.querySelector('[data-vhero-brand]'), px(10), 300, 650, expo);
      var head = document.querySelector('[data-header]');
      if (head && head.getBoundingClientRect().top < 200) {
        lift(head.querySelector('.brand'), px(0), 0, 500, quart);
        lift(head.querySelector('.nav-toggle'), px(8), 120, 700, expo);
        if (window.innerWidth >= 900) {
          lift(head.querySelector('.nav'), px(8), 120, 700, expo);
          head.querySelectorAll('.nav a').forEach(function (a, i) { lift(a, px(4), 260 + i * 45, 700, expo); });
        }
        lift(head.querySelector('.site-header__tools'), px(8), 200, 700, expo);
      }
      lift(hero.querySelector('[data-vhero-lede]'), px(14), 800, 800, expo);
      lift(cta, px(12), 1000, 800, expo);
      lift(hero.querySelector('[data-vhero-link]'), px(8), 1100, 600, quart);
      lift(hero.querySelector('[data-vhero-cue]'), px(-6), 1250, 700, expo);
      reveal();
      Promise.all(anims.map(function (a) { return a.finished; })).then(function () {
        anims.forEach(function (a) { a.cancel(); });
      }).catch(function () {});
    }
    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    var videoReady = new Promise(function (resolve) {
      if (!video || video.readyState >= 2 || (!video.getAttribute('src') && !video.querySelector('source'))) return resolve();
      video.addEventListener('loadeddata', resolve, { once: true });
      video.addEventListener('error', resolve, { once: true });
    });
    Promise.all([fontsReady, videoReady]).then(run);
  });

  // Scroll cue: jump to the section after the hero.
  document.querySelectorAll('[data-vhero-cue]').forEach(function (cue) {
    cue.addEventListener('click', function (event) {
      var wrap = cue.closest('.shopify-section');
      var next = wrap && wrap.nextElementSibling;
      if (!next) return;
      event.preventDefault();
      next.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  });

  // Video hero: muted, looping background with a smooth scroll parallax.
  // As you scroll down the video drifts down at a slower pace and gently zooms out, while the text
  // rises and fades; scrolling back up reverses it. Work only happens while the hero is on screen,
  // and the video pauses when it is out of view or the tab is hidden.
  document.querySelectorAll('[data-vhero]').forEach(function (hero) {
    var stage = hero.querySelector('.vhero__stage');
    var layer = hero.querySelector('[data-vhero-media]');
    var media = hero.querySelector('.vhero__video');
    var copy = hero.querySelector('[data-vhero-copy]');
    if (!stage || !layer || !media) return;
    var isVideo = media.tagName === 'VIDEO';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var inView = true;

    if (isVideo) {
      media.muted = true;
      media.defaultMuted = true;
      var slow = function () { try { media.playbackRate = 0.75; } catch (e) {} };
      var play = function () {
        if (!media.currentSrc && !media.src && !media.querySelector('source')) return;
        if (!inView || document.hidden) return;
        var p = media.play();
        if (p && p.catch) p.catch(function () {});
      };
      slow();
      media.addEventListener('loadedmetadata', slow);
      media.addEventListener('play', slow);
      media.addEventListener('canplay', play);
      document.addEventListener('visibilitychange', function () { document.hidden ? media.pause() : play(); });
      // iOS low-power mode can block autoplay; start on the first touch instead.
      window.addEventListener('touchstart', play, { once: true, passive: true });

      // Swap between the phone and wide versions if the screen shape changes (rotation, resizing).
      if (media.hasAttribute('data-src-desktop')) {
        var portraitMq = window.matchMedia('(max-aspect-ratio: 1/1)');
        var swap = function () {
          var size = portraitMq.matches ? 'mobile' : 'desktop';
          if (media.dataset.size === size) return;
          media.dataset.size = size;
          media.poster = media.dataset[size === 'mobile' ? 'posterMobile' : 'posterDesktop'];
          if (navigator.connection && navigator.connection.saveData) return;
          media.src = media.dataset[size === 'mobile' ? 'srcMobile' : 'srcDesktop'];
          media.load();
          play();
        };
        if (portraitMq.addEventListener) portraitMq.addEventListener('change', swap);
        else if (portraitMq.addListener) portraitMq.addListener(swap);
      }
    }

    var ticking = false;
    function update() {
      ticking = false;
      if (reduced.matches) {
        hero.style.removeProperty('--vhero-y');
        hero.style.removeProperty('--vhero-zoom');
        hero.style.removeProperty('--vhero-copy-y');
        hero.style.removeProperty('--vhero-copy-o');
        return;
      }
      var rect = stage.getBoundingClientRect();
      var h = Math.max(rect.height, 1);
      var p = Math.min(1, Math.max(0, -rect.top / h));
      var eased = 1 - Math.pow(1 - p, 3);
      hero.style.setProperty('--vhero-y', (p * h * 0.3).toFixed(1) + 'px');
      hero.style.setProperty('--vhero-zoom', (1.08 - 0.08 * eased).toFixed(4));
      hero.style.setProperty('--vhero-copy-y', (-p * h * 0.12).toFixed(1) + 'px');
      hero.style.setProperty('--vhero-copy-o', Math.max(0, 1 - p * 1.25).toFixed(3));
    }
    function request() {
      if (!inView || ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (isVideo) inView ? play() : media.pause();
        if (inView) request();
      }, { threshold: 0 }).observe(stage);
    }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    if (reduced.addEventListener) reduced.addEventListener('change', request);
    update();
  });

  // Delivery banner: tap to pause or resume the scrolling text.
  document.querySelectorAll('.announce').forEach(function (bar) {
    bar.addEventListener('click', function () { bar.classList.toggle('is-paused'); });
  });

  // Order confirmation dialog: close on "Back", on a click outside the card, or after continuing.
  document.querySelectorAll('[data-wa-confirm]').forEach(function (dialog) {
    var back = dialog.querySelector('[data-wa-back]');
    if (back) back.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    var go = dialog.querySelector('[data-wa-go]');
    if (go) go.addEventListener('click', function () { setTimeout(function () { dialog.close(); }, 400); });
  });
})();
